import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InputChoice } from '@player/+survey/question/input-choice/input-choice.component';
import { ChoiceLayout } from '@shared/models/survey.model';
import { AsyncPipe, NgClass } from '@angular/common';
import { SharedModuleForPlayer } from '@player/shared/modules/shared.module';
import { PictureImage } from '@player/shared/components/picture-image/picture-image.component';

@Component({
  selector: 'input-choice-picture',
  templateUrl: './input-choice-picture.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SharedModuleForPlayer, NgClass, PictureImage],
})
export class InputChoicePicture extends InputChoice {
  readonly layout = ChoiceLayout;
}
